import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M19 5v14a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2","key":"svg-0"}],["path",{"d":"M8 6h.01","key":"svg-1"}],["path",{"d":"M16 18h.01","key":"svg-2"}],["path",{"d":"M12 12h-1a1 1 0 0 1 -1 -1v-1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v1a1 1 0 0 1 -1 1l-1 0","key":"svg-3"}],["path",{"d":"M12 12h-1a1 1 0 0 0 -1 1v1a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-1a1 1 0 0 0 -1 -1","key":"svg-4"}]]

const IconPlayCard8 = createReactComponent('outline', 'play-card-8', 'PlayCard8', __iconNode);

export default IconPlayCard8;